import { MobileApp } from "../../entity/MobileApp";
import { toDate } from "../../utils/GlobalFunctions";
import { MobileAppDto } from "../dto/MobileApp.Dto";

export class MobileAppMapper {
    static mapToMobileAppDto(mobileApp: MobileAppDto): MobileApp {
        return {
            id: mobileApp.id,
            version: mobileApp.version,
            url: mobileApp.url,
            createdAt: toDate(mobileApp.createdAt),
            updatedAt: toDate(mobileApp.updatedAt),
        };
    }
}
